module.exports = __webpack_public_path__ + "static/media/blockchain.364a3b7d.png";